import { HttpClient } from '@angular/common/http';
import { Injectable, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { firstValueFrom, forkJoin, Observable } from 'rxjs';
import { Client } from './components/product-man/product-man.component';
import { BehaviorSubject } from 'rxjs';
import { environment } from './../environments/environment';
import * as moment from 'moment';
import { userRequest } from './components/user-man/types/user';

const dateFns = require('date-fns');

// Centralized game code constant
export const SIMULATION_GAME_CODE = 'SIM';

@Injectable({
    providedIn: 'root'
})
export class ComponentsService {
    data: any;

    numberOfTickets: number = 0;

    private readonly baseUrl: string = environment.url;

    constructor(private http: HttpClient) {}

    private filteredTiks = new BehaviorSubject([]);
    filteredTikets = this.filteredTiks.asObservable();

    private filteredEvs = new BehaviorSubject([]);
    filteredEvents = this.filteredEvs.asObservable();

    private numOfFilteredTiks = new BehaviorSubject([]);
    numOfFilteredTikets = this.numOfFilteredTiks.asObservable();

    private numOfFilteredEvs = new BehaviorSubject([]);
    numOfFilteredEvents = this.numOfFilteredEvs.asObservable();

    private filteredSlt = new BehaviorSubject([]);
    filteredSlotObservable = this.filteredSlt.asObservable();

    private numOfFilteredSlotGame = new BehaviorSubject([]);
    numOfFilteredSlotGameObservable = this.numOfFilteredSlotGame.asObservable();

    resourceFetching: string;
    resourceFetchingSlot: string;
    getAllTicketsFilters: any;

    deviceType;
    loggedInUser: number;
    clientUuid: string;
    selectedClientUuid: string;

    @Output() openSideBar: EventEmitter<any> = new EventEmitter();
    @Output() iframeEmiter: EventEmitter<any> = new EventEmitter();
    @Output() selectedLocation: EventEmitter<any> = new EventEmitter();
    @Output() selectedUser: EventEmitter<any> = new EventEmitter();
    @Output() timeZoneChanged: EventEmitter<any> = new EventEmitter();
    @Output() newTicketBatch: EventEmitter<any> = new EventEmitter();
    @Output() loadingTickets: EventEmitter<any> = new EventEmitter();
    @Output() selectedUserUuid: EventEmitter<any> = new EventEmitter();
    @Output() loadingUsers: EventEmitter<any> = new EventEmitter();
    @Output() loadingPos: EventEmitter<any> = new EventEmitter();

    @Output() loadingTicketsNum: EventEmitter<any> = new EventEmitter();
    @Output() loadingTicketsStatistic: EventEmitter<any> = new EventEmitter();
    @Output() tiketCode: EventEmitter<any> = new EventEmitter();
    @Output() clientChanged: EventEmitter<any> = new EventEmitter();
    @Output() newEventId: EventEmitter<any> = new EventEmitter();
    @Output() refreshPage: EventEmitter<any> = new EventEmitter();
    @Output() filtering: EventEmitter<any> = new EventEmitter();
    // @Output() paginationChangesEvent: EventEmitter<any> = new EventEmitter();
    // @Output() paginationChangesTiket: EventEmitter<any> = new EventEmitter();
    @Output() paginationChanges: EventEmitter<any> = new EventEmitter();
    @Output() emptyRaceDet: EventEmitter<any> = new EventEmitter();
    @Output() jackpotTableSwitch: EventEmitter<any> = new EventEmitter();
    @Output() ticketsStatistics: EventEmitter<any> = new EventEmitter();
    @Output() slotGameplayDataSubject: EventEmitter<any> =
        new EventEmitter<any>();
    @Output() slotGameplayDataSubjectNum: EventEmitter<any> =
        new EventEmitter<any>();
    @Output() loadingSlotsStatistic: EventEmitter<any> = new EventEmitter();
    @Output() loadingSlotsGamePlay: EventEmitter<any> = new EventEmitter();
    @Output() loadingSlotsNum: EventEmitter<any> = new EventEmitter();
    @Output() slotsStatistics: EventEmitter<any> = new EventEmitter();
    @Output() ticketDetailsEmmiter: EventEmitter<any> = new EventEmitter();

    info;
    headers = {
        redirect: 'follow',
        withCredentials: true
    };

    private TIMEZONE_OFFSET: any = new Date().getTimezoneOffset();
    private SERVER_TIMEZONE_OFFSET: any;

    addTimeZoneOffset(time) {
        const TIME_OFFSET_IN_MS =
            (this.getTimeZoneOffset() +
                Math.abs(this.getServerTimeZoneOffset())) *
            60000;
        const parsedDateTime = dateFns.parse(
            time,
            'dd/MM/yyyy HH:mm:ss',
            new Date()
        );
        const milliseconds = parsedDateTime.getTime();
        return this.getTimeZoneOffset() >= 0
            ? moment(milliseconds - TIME_OFFSET_IN_MS).format(
                  'DD/MM/YYYY HH:mm:ss'
              )
            : moment(milliseconds - TIME_OFFSET_IN_MS).format(
                  'DD/MM/YYYY HH:mm:ss'
              );
    }

    setTimeZoneOffset(timeZoneOffset: any) {
        this.TIMEZONE_OFFSET = timeZoneOffset;
    }

    getTimeZoneOffset(): any {
        return this.TIMEZONE_OFFSET;
    }

    setServerTimeZoneOffset(timeZoneOffset: any) {
        this.SERVER_TIMEZONE_OFFSET = timeZoneOffset;
    }

    getServerTimeZoneOffset(): any {
        return this.SERVER_TIMEZONE_OFFSET;
    }

    getSlotStatistics(clientUuid, gameType, gameCode): Observable<any> {
        return this.http.post<Client[]>(
            `${this.baseUrl}/slots/getSlotStatistics`,
            {
                clientUuid,
                gameType,
                username: this.info.username,
                gameCode
            },
            this.headers
        );
    }

    getGames(clientUuid): Observable<any> {
        return this.http.post<Client[]>(
            `${this.baseUrl}/games/getGames`,
            {
                clientUuid,
                username: this.info.username
            },
            this.headers
        );
    }

    getAllGames(): Observable<any> {
        return this.http.post<any>(
            `${this.baseUrl}/games/getAllGames`,
            { username: this.info.username },
            this.headers
        );
    }

    getGameType(): Observable<any> {
        return this.http.post<any>(
            `${this.baseUrl}/gameTypes/getGameType`,
            { username: this.info.username },
            this.headers
        );
    }

    getClientNames(): Observable<any> {
        return this.http.post<any>(
            `${this.baseUrl}/client/getClientNames`,
            { username: this.info.username },
            this.headers
        );
    }

    getTicketsPerPage(
        startNumber: number,
        numberOfRows: number,
        clientUuid: string,
        gameType: string,
        gameCode: string,
        additionalFilters: Object,
        superAdmin: number,
        dataFilter?: Object
    ): Observable<any> {
        let dbData = this.http.post<any>(
            `${this.baseUrl}/ticket/getTicketPerPage`,
            {
                dbType: 'production',
                startNum: startNumber,
                numberOfRows: numberOfRows,
                clientUuid,
                gameType,
                gameCode,
                additionalFilters: additionalFilters,
                superAdmin: superAdmin,
                dataFilter: dataFilter,
                username: this.info.username,
                offset: this.getTimeZoneOffset()
            },
            this.headers
        );
        let dbArchiveData = this.http.post<any>(
            `${this.baseUrl}/ticket/getTicketPerPage`,
            {
                dbType: 'archive',
                startNum: startNumber,
                numberOfRows: numberOfRows,
                clientUuid,
                gameType,
                gameCode,
                additionalFilters: additionalFilters,
                superAdmin: superAdmin,
                dataFilter: dataFilter,
                username: this.info.username,
                offset: this.getTimeZoneOffset()
            },
            this.headers
        );

        return forkJoin([dbData, dbArchiveData]);
    }

    getTicketsStatistic(
        clientUuid: string,
        gameType: string,
        gameCode: string,
        startDate: string,
        endDate: string,
        device: string,
        shop_id: any,
        user_id: any
    ): Observable<any> {
        let dbData = this.http.post<any>(
            `${this.baseUrl}/ticket/getTicketsStatistic`,
            {
                dbType: 'production',
                clientUuid,
                gameType,
                gameCode,
                startDate: startDate,
                endDate: endDate,
                device: device,
                shop_id: shop_id,
                user_id: user_id,
                username: this.info.username
            },
            this.headers
        );
        let dbArchiveData = this.http.post<any>(
            `${this.baseUrl}/ticket/getTicketsStatistic`,
            {
                dbType: 'archive',
                clientUuid,
                gameType,
                gameCode,
                startDate: startDate,
                endDate: endDate,
                device: device,
                shop_id: shop_id,
                user_id: user_id,
                username: this.info.username
            },
            this.headers
        );

        return forkJoin([dbData, dbArchiveData]);
    }

    getTicketNum(clientUuid, gameCode, dataFilter?: Object): Observable<any> {
        let dbData = this.http.post<any>(
            `${this.baseUrl}/ticket/getTicketNum`,
            {
                dbType: 'production',
                body: {
                    clientUuid,
                    gameCode,
                    dataFilter: dataFilter
                },
                username: this.info.username
            },
            this.headers
        );
        let dbArchiveData = this.http.post<any>(
            `${this.baseUrl}/ticket/getTicketNum`,
            {
                dbType: 'archive',
                body: {
                    clientUuid,
                    gameCode,
                    dataFilter: dataFilter
                },
                username: this.info.username
            },
            this.headers
        );
        return forkJoin([dbData, dbArchiveData]);
    }

    getIncrements(clientUuid: string, gameCode: string, ccy: string) {
        return this.http.post<any>(
            `${this.baseUrl}/settings/getIncrements`,
            {
                clientUuid,
                gameCode,
                ccy,
                username: this.info.username
            },
            this.headers
        );
    }

    setUsersPerm(data) {
        console.log(
            `[ComponentsService] setUsersPerm called with clientUuid: ${data?.clientUuid}`
        );
        this.info = data;
        if (data && data.clientUuid) {
            this.setClientUuid(data.clientUuid);
            this.setSelectedClientUuid(data.clientUuid);
        }
    }

    getUsersPerm() {
        return this.info;
    }

    //KADA SE MENJA KLIJENT (  SUPER ADMIN );
    changeClient(clientUuid) {
        this.info.clientUuid = clientUuid;
        this.setClientUuid(clientUuid);
        this.setSelectedClientUuid(clientUuid);
    }

    //KADA SE MENJA KLIJENT (  SUPER ADMIN );

    changeSettings(newValues, clientUuid, gameCode): Observable<any> {
        return this.http.post<any>(
            `${this.baseUrl}/settings/changeValues`,
            {
                newValues: newValues,
                clientUuid,
                gameCode,
                username: this.info.username
            },
            this.headers
        );
    }

    changeBetSettings(newValues, clientUuid, gameCode): Observable<any> {
        return this.http.post<any>(
            `${this.baseUrl}/settings/changeBetSettings`,
            {
                newValues,
                clientUuid,
                gameCode,
                username: this.info.username
            },
            this.headers
        );
    }

    getSettings(clientUuid, gameCode, gameType): Observable<any> {
        return this.http.post<any>(
            `${this.baseUrl}/settings/getSettings`,
            {
                gameCode,
                clientUuid,
                gameType: gameType,
                username: this.info.username
            },
            this.headers
        );
    }

    getUsers(clientUuid, superAdmin?): Promise<any> {
        return firstValueFrom(
            this.http.post<any>(
                `${this.baseUrl}/user/getUsers`,
                {
                    clientUuid,
                    superAdmin,
                    username: this.info.username
                },
                this.headers
            )
        );
    }

    getUser(user): Observable<any> {
        return this.http.post<any>(
            `${this.baseUrl}/user/getUser`,
            {
                user: { ...user, clientUuid: this.getClientUuid() },
                username: this.info.username
            },
            this.headers
        );
    }

    updateUser(user: userRequest): Promise<any> {
        return firstValueFrom(
            this.http.post<any>(
                `${this.baseUrl}/user/updateUser`,
                user,
                this.headers
            )
        );
    }

    insertUser(user: userRequest): Promise<any> {
        return firstValueFrom(
            this.http.post<any>(
                `${this.baseUrl}/user/insertUser`,
                user,
                this.headers
            )
        );
    }

    unlockUser(user_id): Observable<any> {
        return this.http.post<any>(
            `${this.baseUrl}/user/unlockUser`,
            {
                user_id: user_id,
                clientUuid: this.getClientUuid(),
                blocked_until: null,
                username: this.info.username
            },
            this.headers
        );
    }

    blockUser(user_id): Observable<any> {
        return this.http.post<any>(
            `${this.baseUrl}/user/blockUser`,
            {
                user_id: user_id,
                clientUuid: this.getClientUuid(),
                active: 0,
                username: this.info.username
            },
            this.headers
        );
    }

    changePassword(user): Observable<any> {
        return this.http.post<any>(
            `${this.baseUrl}/user/changePassword`,
            {
                user: user,
                clientUuid: this.getClientUuid(),
                clientsUsername: this.info.username
            },
            this.headers
        );
    }

    clientName(clientUuid: string): Observable<any> {
        return this.http.post<any>(
            `${this.baseUrl}/client/getClientName`,
            {
                clientUuid,
                username: this.info.username
            },
            this.headers
        );
    }

    receiveFilteredTikets(tikets) {
        this.resourceFetching = 'tikets';
        this.filteredTiks.next(tikets);
    }

    numberOfFilteredTickets(num) {
        this.numOfFilteredTiks.next(num);
    }

    setDeviceType(deviceType) {
        if (!deviceType) {
            deviceType = 'all';
        }
        this.deviceType = deviceType;
    }

    getDeviceType() {
        return this.deviceType;
    }

    setClientUuid(clientUuid) {
        this.clientUuid = clientUuid;
    }

    getClientUuid() {
        return this.clientUuid;
    }

    setSelectedClientUuid(clientUuid: string) {
        this.selectedClientUuid = clientUuid;
    }

    resetClientUuids() {
        this.clientUuid = null;
        this.selectedClientUuid = null;
    }

    getSelectedClientUuid() {
        // Return selected client UUID if set, otherwise fall back to logged-in user's client UUID
        const selectedUuid = this.selectedClientUuid || this.clientUuid;
        console.log(
            `[ComponentsService] getSelectedClientUuid: selectedClientUuid=${this.selectedClientUuid}, clientUuid=${this.clientUuid}, returning=${selectedUuid}`
        );
        return selectedUuid;
    }

    getSimulationGameCode(): string {
        return SIMULATION_GAME_CODE;
    }

    getSimulationGameType(): string {
        return 'virtual_sport';
    }

    requestUsersMulti(clientUuid, user, superAdmin?): Observable<any[]> {
        let response2 = this.http.post<any>(
            `${this.baseUrl}/user/getUsers`,
            {
                clientUuid,
                superAdmin,
                username: this.info.username
            },
            this.headers
        );
        let response3 = this.http.post<any>(
            `${this.baseUrl}/user/getUser`,
            {
                user: user,
                username: this.info.username
            },
            this.headers
        );
        return forkJoin([response2, response3]);
    }

    requestSettings(clientUuid, gameType, gameCode) {
        let response1 = this.http.post<any>(
            `${this.baseUrl}/settings/getSettings`,
            {
                clientUuid,
                gameType,
                gameCode,
                username: this.info.username
            },
            this.headers
        );
        return forkJoin([response1]);
    }

    getBettSettings(clientUuid: string, gameCode: string): Observable<any> {
        return this.http.post<any>(
            `${this.baseUrl}/settings/betSettings`,
            {
                clientUuid,
                gameCode,
                username: this.info.username
            },
            this.headers
        );
    }

    getAllBettingStatus(): Observable<any> {
        return this.http.post<any>(
            `${this.baseUrl}/betcontrol/getAllBettingStatus`,
            { username: this.info.username },
            this.headers
        );
    }

    getRevenueForSelectedYearAndMonth(
        year: number,
        month: number
    ): Observable<any> {
        const body = {
            year: year,
            month: month
        };
        return this.http.post<any>(
            `${this.baseUrl}/betcontrol/getRevenueForSelectedYearAndMonth`,
            { year, month, username: this.info.username },
            this.headers
        );
    }

    getSingleBettingStatus(
        clientUuid: string,
        gameCode: string
    ): Observable<any> {
        return this.http.post<any>(
            `${this.baseUrl}/betcontrol/getSingleBettingStatus`,
            {
                clientUuid,
                gameCode,
                username: this.info.username
            },
            this.headers
        );
    }

    setAllBettingStatus(value: number, username: string): Observable<any> {
        return this.http.post<any>(
            `${this.baseUrl}/betcontrol/setAllBettingStatus`,
            { value: value, username: this.info.username },
            this.headers
        );
    }

    setSingleBettingStatus(value: number, gameCode: string): Observable<any> {
        return this.http.post<any>(
            `${this.baseUrl}/betcontrol/setSingleBettingStatus`,
            {
                username: this.info.username,
                value: value,
                clientUuid: this.getClientUuid(),
                gameCode
            },
            this.headers
        );
    }

    setGameBettingStatus(value: number, gameCode: string): Observable<any> {
        return this.http.post<any>(
            `${this.baseUrl}/betcontrol/setGameBettingStatus`,
            {
                username: this.info.username,
                value: value,
                gameCode
            },
            this.headers
        );
    }

    // Function to subscribe to the slot gameplay data observable
    onSlotGameplayData(): Observable<any> {
        return this.slotGameplayDataSubject.asObservable();
    }

    // Function to subscribe to the slot gameplay data observable
    onSlotGameplayDataNum(): Observable<any> {
        return this.slotGameplayDataSubjectNum.asObservable();
    }

    // Function to fetch slot gameplay data
    getSlotGameplayData(
        clientUuid: string,
        gameType: string,
        gameCode: string,
        filters: any,
        page: number,
        pageSize: number,
        created: string,
        pagingDirection: string,
        offset: any
    ): Observable<any> {
        const requestData = {
            dbType: 'production',
            clientUuid,
            gameType,
            gameCode,
            filters: filters,
            page: page,
            pageSize: pageSize,
            created: created,
            pagingDirection: pagingDirection,
            offset: this.getTimeZoneOffset()
        };

        const requestDataArchive = {
            dbType: 'archive',
            clientUuid,
            gameType,
            gameCode,
            filters: filters,
            page: page,
            pageSize: pageSize,
            created: created,
            pagingDirection: pagingDirection,
            offset: this.getTimeZoneOffset()
        };

        let dbData = this.http.post<any>(
            `${this.baseUrl}/slot-gameplay/getSlotGameplayData`,
            requestData,
            this.headers
        );
        let dbArchiveData = this.http.post<any>(
            `${this.baseUrl}/slot-gameplay/getSlotGameplayData`,
            requestDataArchive,
            this.headers
        );

        return forkJoin([dbData, dbArchiveData]);
    }

    getGameplayStats(
        clientUuid: string,
        gameType: string,
        gameCode: string,
        startDate: string,
        endDate: string
    ): Observable<any> {
        const requestData = {
            dbType: 'production',
            clientUuid,
            gameType,
            gameCode,
            startDate,
            endDate
        };
        const requestDataArchive = {
            dbType: 'archive',
            clientUuid,
            gameType,
            gameCode,
            startDate,
            endDate
        };

        // console.log('statistika statistika statistika ', requestData);
        // return this.http.post<any>(`${environment.url}:${environment.port}/slot-gameplay/stats/${clientId}/${gameCode}`, requestData);

        let dbData = this.http.post<any>(
            `${this.baseUrl}/slot-gameplay/stats/${clientUuid}/${gameCode}`,
            requestData,
            this.headers
        );
        let dbArchiveData = this.http.post<any>(
            `${this.baseUrl}/slot-gameplay/stats/${clientUuid}/${gameCode}`,
            requestDataArchive,
            this.headers
        );

        return forkJoin([dbData, dbArchiveData]);
    }

    getSlotGameplayNum(
        clientUuid: string,
        gameType: string,
        gameCode: string,
        filters: any
    ): Observable<any> {
        const body = {
            dbType: 'production',
            clientUuid,
            gameType,
            gameCode,
            filters: filters
            // additionalFilters: additionalFilters
        };

        const bodyArchive = {
            dbType: 'archive',
            clientUuid,
            gameType,
            gameCode,
            filters: filters
            // additionalFilters: additionalFilters
        };

        let dbData = this.http.post<any>(
            `${this.baseUrl}/slot-gameplay/getSlotGameplayNum`,
            body,
            this.headers
        );
        let dbArchiveData = this.http.post<any>(
            `${this.baseUrl}/slot-gameplay/getSlotGameplayNum`,
            bodyArchive,
            this.headers
        );

        return forkJoin([dbData, dbArchiveData]);
    }

    getCurrency(): Observable<any> {
        return this.http.post<any>(
            `${this.baseUrl}/currency-management/currencies`,
            {
                clientUuid: this.getClientUuid()
            },
            this.headers
        );
    }

    getExchangeRate(): Observable<any> {
        return this.http.post<any>(
            `${this.baseUrl}/currency-management/exchange-rates`,
            {
                clientUuid: this.getClientUuid()
            },
            this.headers
        );
    }

    getExchangeRateHistory(
        date: string,
        currency_code?: string
    ): Observable<any> {
        let data = {
            date: date,
            currencyCode: currency_code,
            clientUuid: this.getClientUuid()
        };

        return this.http.post<any>(
            `${this.baseUrl}/currency-management/exchange-rate-histories`,
            data,
            this.headers
        );
    }

    getDisplayCcy(): Observable<any> {
        return this.http.post<any>(
            `${this.baseUrl}/currency-management/display-ccy`,
            {
                clientUuid: this.getClientUuid()
            },
            this.headers
        );
    }

    getClientName(clientUuid: string): Observable<any> {
        return this.http.post<any>(
            `${this.baseUrl}/blocked-players/getClientName`,
            { clientUuid },
            this.headers
        );
    }

    getBlockedPlayers(clientUuid: string): Promise<any> {
        return firstValueFrom(
            this.http.post<any>(
                `${this.baseUrl}/blocked-players/BlockedPlayers`,
                { clientUuid },
                this.headers
            )
        );
    }

    getBetstopStatus(): Promise<any> {
        return firstValueFrom(
            this.http.post<any>(
                `${this.baseUrl}/settings/getBetstopStatus`,
                {},
                this.headers
            )
        );
    }

    stopbet(
        clientUuid: string,
        reason: string,
        isSuperAdmin: boolean,
        value: boolean
    ): Promise<any> {
        return firstValueFrom(
            this.http.post<any>(
                `${this.baseUrl}/settings/${isSuperAdmin ? 'super' : ''}betstop`,
                {
                    clientUuid,
                    reason,
                    betstopValue: value,
                    userId: this.getUsersPerm().userId
                },
                this.headers
            )
        );
    }

    getBetstopStatusForClient(clientUuid: string): Promise<any> {
        return firstValueFrom(
            this.http.post<any>(
                `${this.baseUrl}/settings/getBetstopStatusForClient`,
                { clientUuid },
                this.headers
            )
        );
    }

    insertBlockedPlayer(playerData: any): Promise<any> {
        return firstValueFrom(
            this.http.post<any>(
                `${this.baseUrl}/blocked-players/playerData`,
                {
                    playerData: playerData,
                    clientUuid: this.getClientUuid()
                },
                this.headers
            )
        );
    }

    updateBlockedPlayer(playerData: any): Promise<any> {
        return firstValueFrom(
            this.http.post<any>(
                `${this.baseUrl}/blocked-players/playerDataUpdate`,
                {
                    playerData: playerData,
                    clientUuid: this.getClientUuid()
                },
                this.headers
            )
        );
    }

    getTranslation(
        clientUuid: string,
        gameCode: string,
        language: string,
        gameType: string
    ): Observable<any> {
        return this.http.post<any>(
            `${this.baseUrl}/translation/getTranslation`,
            {
                clientUuid,
                gameCode,
                language,
                gameType
            },
            this.headers
        );
    }

    getLanguageSupport(clientUuid: string, gameCode: string, gameType: string) {
        return this.http.post<any>(
            `${this.baseUrl}/translation/getLanguageSupport`,
            {
                clientUuid,
                gameCode,
                gameType
            },
            this.headers
        );
    }

    updateTranslation(
        clientUuid: string,
        gameCode: string,
        language: string,
        newTranslation: string,
        gameType: string
    ) {
        return this.http.post<any>(
            `${this.baseUrl}/translation/updateTranslation`,
            {
                clientUuid,
                gameCode,
                language,
                newTranslation,
                gameType
            },
            this.headers
        );
    }

    getTheme(clientUuid: string, gameCode: string): Observable<any> {
        return this.http.post<any>(
            `${this.baseUrl}/settings/getTheme`,
            {
                clientUuid,
                gameCode
            },
            this.headers
        );
    }

    changeTheme(
        clientUuid: string,
        gameCode: string,
        theme: any
    ): Observable<any> {
        return this.http.post<any>(
            `${this.baseUrl}/settings/changeTheme`,
            {
                clientUuid,
                gameCode,
                theme,
                username: this.info.username
            },
            this.headers
        );
    }

    getAllTicketsForClient(clientUuid: string, filters: any) {
        const body: any = {
            clientUuid,
            ...filters
        };

        // Store only the filters, not the clientUuid (which is client-specific)
        this.getAllTicketsFilters = { ...filters };

        return this.http.post<any>(
            `${this.baseUrl}/ticket/getTicketsForClient`,
            body,
            this.headers
        );
    }

    getAllClientInfo(clientObjects: any, filters: any) {
        console.log('getAllClientInfo called with:', {
            clientObjects,
            filters
        });

        // Extract clientUuid from client objects if they are objects, otherwise use as is
        const clients = clientObjects.map((client) => {
            if (typeof client === 'object' && client.clientUuid) {
                return client.clientUuid;
            }
            return client;
        });

        const body = {
            clients,
            ...filters
        };

        console.log(
            'Sending request to /ticket/getClientsInfo with body:',
            body
        );

        return this.http.post<any>(
            `${this.baseUrl}/ticket/getClientsInfo`,
            body,
            this.headers
        );
    }
}
